import React from 'react';
import type { BooleanInputFieldProps } from '../types';
import * as S from './styles';
export type Props = BooleanInputFieldProps;
const InputToggle: React.FC<Props> = ({
  value: propValue,
  setValue,
  disabled,
  id
}) => {
  const toggle = event => {
    event.preventDefault();
    setValue?.(v => !v);
  };
  return <S.Toggle onClick={disabled ? undefined : e => toggle(e)} toggled={propValue} disabled={disabled} id={id} type="button">
      <S.IconContainer toggled={propValue} key="IconContainer">
        {propValue ? <S.IconEnable /> : <S.IconDisable />}
      </S.IconContainer>
    </S.Toggle>;
};
export default InputToggle;